var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconPaste = function SvgIconPaste(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.82 19.52H6.18V6.16h1.64v2.5h8.36v-2.5h1.64zM12 4.52q.351 0 .586.234a.8.8 0 0 1 .234.586q0 .351-.234.586A.8.8 0 0 1 12 6.16a.8.8 0 0 1-.586-.234.8.8 0 0 1-.234-.586q0-.351.234-.586A.8.8 0 0 1 12 4.52m5.82 0h-3.476a2.6 2.6 0 0 0-.899-1.211A2.34 2.34 0 0 0 12 2.84q-.82 0-1.445.469a2.6 2.6 0 0 0-.899 1.21H6.18q-.705 0-1.211.47-.47.469-.469 1.171v13.36q0 .703.469 1.172.507.468 1.21.468H17.82q.704 0 1.172-.468.508-.47.508-1.172V6.16q0-.703-.508-1.172-.468-.468-1.172-.468"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconPaste);
export { ForwardRef as ReactComponent };